import { ApplicationConfig, ENVIRONMENT_INITIALIZER, inject, LOCALE_ID } from "@angular/core";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import { provideFuse } from '../../../shared/src/lib/@fuse/fuse.provider';
import { provideIcons } from '../../../shared/src/lib/icons/icons.provider';
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { AuthInterceptor } from "../../../shared/src/lib/interceptors/auth.interceptor";
import { authProviderInterceptor } from "../../../shared/src/lib/interceptors/authProvider.interceptor";
import { AuthenticationService } from "../../../shared/src/lib/service/authentification.service";

export const aiExamConfig: ApplicationConfig = {
    providers: [
        provideAnimations(),
        // Material Date Adapter
        {
            provide : DateAdapter,
            useClass: LuxonDateAdapter,
        },
        {
            provide : MAT_DATE_FORMATS,
            useValue: {
                parse  : {
                    dateInput: 'D',
                },
                display: {
                    dateInput         : 'DDD',
                    monthYearLabel    : 'LLL yyyy',
                    dateA11yLabel     : 'DD',
                    monthYearA11yLabel: 'LLLL yyyy',
                },
            },
        },
        { provide: MAT_DATE_LOCALE, useValue: 'fr' },
        { provide: LOCALE_ID, useValue: 'fr-fr' },
        provideHttpClient(withInterceptors([authProviderInterceptor])),
        {
            provide : ENVIRONMENT_INITIALIZER,
            useValue: () => inject(AuthenticationService),
            multi   : true,
        },
        // Fuse
        provideIcons(),
        provideFuse({
            fuse   : {
                layout: 'classy',
                scheme: 'light',
                theme : 'theme-brand',
                screens: {
                    sm: '600px',
                    md: '960px',
                    lg: '1280px',
                    xl: '1440px',
                },
                themes : [
                    {
                        id  : 'theme-default',
                        name: 'Default',
                    },
                    {
                        id  : 'theme-brand',
                        name: 'Brand',
                    },
                    {
                        id  : 'theme-teal',
                        name: 'Teal',
                    },
                    {
                        id  : 'theme-rose',
                        name: 'Rose',
                    },
                    {
                        id  : 'theme-purple',
                        name: 'Purple',
                    },
                    {
                        id  : 'theme-amber',
                        name: 'Amber',
                    },
                ],
            },
        }),

        provideAnimations()
    ],
};